<template>
  <div id="rule">
    <h2>ゲームの説明</h2>
    <v-card
      max-width=720
      class="card-component"
      color="rgba(0,0,0,0.2)"
    >
      <h3>ルール</h3>
      <ul>
        <li>本ゲームは政府転覆を目論む"レジスタンス"陣営とそれを阻止する"スパイ"陣営に分かれて行うゲームである．</li>
        <li>全員の信任投票で承認されたメンバーでミッションを最大５回行う．</li>
        <li>ミッションを3回成功させることができれば"レジスタンス"陣営の勝利．ミッションが３回失敗した場合"スパイ"陣営の勝利となる．</li>
        <li>プレイヤーはいつ，何を話してもよい．ゲームの勝利には議論，嘘，直観，人間関係，論理的推察の全てが等しく必要となる．</li>
      </ul>
    </v-card>

    <v-card
      max-width=720
      class="card-component"
      color="rgba(0,0,0,0.2)"
    >
      <h3>ゲームの準備</h3>
      <ul>
        <li>まず，プレイヤーは事前に自分の役割（レジスタンス or スパイ）を確認する．</li>
        <li>レジスタンスの場合，他のプレイヤーの役職は"不明"と表示される．</li>
        <li>スパイの場合，他のプレイヤーの役職．</li>
        <li>ゲームの準備後，ラウンドへ入る．</li>
      </ul>
    </v-card>

    <v-card
      max-width=720
      class="card-component"
      color="rgba(0,0,0,0.2)"
    >
      <h3>ゲームの流れ</h3>
      <ul>
        <li>ラウンド毎にミッション参加メンバーを確定しミッションを実行する．ラウンドは以下の流れに沿って行われれる．（ラウンドは最大５回まで行われる．）</li>
        <ol>
          <li>ミッションメンバーを選出</li>
          <li>ミッションメンバーへ投票</li>
          <li>ミッション実行</li>
        </ol>
        <br>
        <ol>
          <li>ミッションメンバーを選出</li>
          <ul>
            <li>ミッションに参加するメンバー（以下，ミッションメンバー）をリーダーが選出する．（ミッションに参加する人数はプレイ人数とラウンドによって異なる．詳細は別途説明．）</li>
          </ul>
          <li>ミッションメンバーへ投票</li>
          <ul>
            <li>リーダーによりミッションメンバーに対して全員で同時に承認or否認を投票する．承認が過半数を超えてた場合メンバーは可決される．（承認と否認が同数の場合は否決．）</li>
            <li>ミッションメンバーが否決されるとリーダーを次の人に変更し再度，『①ミッションメンバーの選出』を実施する．</li>
            <li>１回のラウンドでミッションメンバーが5回否決されるとその時点でスパイ陣営の勝利となる．</li>
          </ul>
          <li>ミッション実行</li>
          <ul>
            <li>ミッションメンバーにてミッションを行う．</li>
            <li>ミッションメンバーはミッションを完遂するか妨害するかを選択する．レジスタンスは遂行しか選択できる．スパイはどちらかを選択できる．</li>
            <li>ミッションメンバー全員が完遂を選択した場合，ミッションは成功となる．一人でも妨害を選択したメンバーがいた場合，そのミッションは失敗となる．</li>
          </ul>
        </ol>
      </ul>
    </v-card>

    <v-card
      max-width=720
      class="card-component"
      color="rgba(0,0,0,0.2)"
    >
      <h3><p>その他</p></h3>
      <ul>
        <li>プレイ人数とレジスタンス，スパイの内訳は以下の通り．</li>
        <table class="center">
          <tr>
            <th width="100">プレイ人数</th>
            <th width="100">レジスタンス</th>
            <th width="100">スパイ</th>
          </tr>
          <tr>
            <td>5</td>
            <td>3</td>
            <td>2</td>
          </tr>
          <tr>
            <td>6</td>
            <td>4</td>
            <td>2</td>
          </tr>
          <tr>
            <td>7</td>
            <td>4</td>
            <td>3</td>
          </tr>
          <tr>
            <td>8</td>
            <td>5</td>
            <td>3</td>
          </tr>
          <tr>
            <td>9</td>
            <td>6</td>
            <td>3</td>
          </tr>
          <tr>
            <td>10</td>
            <td>6</td>
            <td>4</td>
          </tr>
        </table>
        <li>プレイ人数とラウンド毎のミッションメンバーの人数は以下の通り．<br>
        ※*が付いているミッションでは2人以上が裏切りを選択しないと失敗にはならない．</li>
        <table class="center">
          <tr>
            <th rowspan="2" width="100">プレイ人数</th>
            <th colspan="5">ラウンド</th>
          </tr>
          <tr>
            <th width="50">1</th>
            <th width="50">2</th>
            <th width="50">3</th>
            <th width="50">4</th>
            <th width="50">5</th>
          </tr>
          <tr>
            <td>5</td>
            <td>2</td>
            <td>3</td>
            <td>2</td>
            <td>3</td>
            <td>3</td>
          </tr>
          <tr>
            <td>6</td>
            <td>2</td>
            <td>3</td>
            <td>4</td>
            <td>3</td>
            <td>4</td>
          </tr>
          <tr>
            <td>7</td>
            <td>2</td>
            <td>3</td>
            <td>3</td>
            <td>4*</td>
            <td>4</td>
          </tr>
          <tr>
            <td>8</td>
            <td>3</td>
            <td>4</td>
            <td>4</td>
            <td>5*</td>
            <td>5</td>
          </tr>
          <tr>
            <td>9</td>
            <td>3</td>
            <td>4</td>
            <td>4</td>
            <td>5*</td>
            <td>5</td>
          </tr>
          <tr>
            <td>10</td>
            <td>3</td>
            <td>4</td>
            <td>4</td>
            <td>5*</td>
            <td>5</td>
          </tr>
        </table>
      </ul>
    </v-card>
    <router-link to="/" style="text-decoration:none;">
      <v-btn class="white--text send-button mb-6" large tile color="#205020" max-width=190><b>ホームに戻る</b></v-btn>
    </router-link>
  </div>
</template>
<script>
export default {
  name: 'rule',

}
</script>
<style>
#rule {
  position: relative; /*相対位置*/
  background-image: url("~@/assets/background.jpg");
  background-size: auto;
  background-attachment: fixed;
  /* Full height */
  height: 100%;

  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  /* width: 20% */
}
#rule h2 {
  padding-top: 16px;
  color: white;
}
#rule h3 {
  margin-bottom: 12px;
  color: white;
}
#rule li{
  text-align: left;
  color: #FFF;
}
#rule p {
  color: #FFF;
}
#rule .card-component {
  margin: 24px auto;
  padding: 16px 16px;
}

#rule table {
  border-collapse: collapse;
  border: 1px solid white;
  margin-top: 12px;
  margin-bottom: 12px;
  color: #FFF;
}

#rule td{
  border: 1px solid white;
}

#rule th{
  border: 1px solid white;
}

#rule .center {
  margin-left: auto;
  margin-right: auto;
}
</style>
